import React, {useCallback} from 'react';
import {Select, CheckBox, PriorityIcon} from '@priority-software/priority-style-react';
import {observer} from 'mobx-react';
import {SelectHeader} from './SelecctHeader';
import texts from '../texts';

export const DialogSelect = observer(props => {
    const {companiesStore} = props;
    const {searchValue, isAllSelected, companies, selectedCompanies, totalNumOfResults} =
        companiesStore;

    const setValue = useCallback(
        value => {
            companiesStore.setValue(value);
        },
        [companiesStore]
    );

    const inputChangeHandler = useCallback(
        (value, actionObj) => {
            const {action} = actionObj;
            if (action !== 'input-blur' && action !== 'menu-close' && action !== 'set-value') {
                setValue(value);
            }
        },
        [setValue]
    );

    const onChooseHandler = (selectedOptions, option) => {
        if (option?.action === 'select-option') {
            option.option?.setSelected(true);
        } else if (option?.action === 'deselect-option') {
            option.option?.setSelected(false);
        }
    };

    const renderItem = (data, isSelected) => {
        return (
            <CheckBox ariaLabel={data.label} checked={isSelected} tabIndex={-1}>
                {data.label}
            </CheckBox>
        );
    };

    return (
        <Select
            size="large"
            shadow={false}
            staticList
            openMenuOnFocus
            isSearchClearable
            onInputClear={() => setValue('')}
            inputValue={searchValue}
            onInputChange={inputChangeHandler}
            onChange={onChooseHandler}
            hideSelectControl={totalNumOfResults < 10}
            isSearchable
            indicatorIcon={PriorityIcon.searchThin}
            controlShouldRenderValue={false}
            filterOption={null}
            autoFocus
            menuScrollMaxHeight={230}
            menuScrollMinHeight={230}
            placeholder={texts.search}
            tabSelectsValue={false}
            noOptionsMessage={() => texts.noResults}
            options={companies}
            value={selectedCompanies}
            isMulti
            renderItem={renderItem}
            header={() => (
                <SelectHeader
                    store={companiesStore}
                    filteredCompanies={companies}
                    isAllSelected={isAllSelected}
                />
            )}
        />
    );
});
